/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import {
    TrendingUp,
    Activity,
    RotateCcw,
    AlertTriangle
} from "lucide-react";

import { fetchTable } from "../../api";

export default function MarketPulse() {

    const [cards, setCards] = useState([]);

    useEffect(() => {

        fetchTable("ta", "nifty_50").then((taData) => {
            console.log("MARKET PULSE",taData)

            if (!JSON.parse(taData)?.data) return;
            const rows = JSON.parse(taData).data;
            console.log("MARKET PULSE rows",rows)

            const bullish = rows.filter(
                r =>
                    r[1] > r[5] &&   // Close > SuperTrend
                    r[3] > 0         // MACD_H > 0
            );

            const weak = rows.filter(
                r =>
                    r[1] < r[5] &&   // Close < SuperTrend
                    r[3] < 0         // MACD_H < 0
            );

            const breakouts = rows.filter(
                r =>
                    r[1] >= r[8] * 0.98 && // Near upper BB
                    r[3] > 0
            );

            const oversold = rows.filter(
                r =>
                    r[9] < 20 && // STOCH RSI K
                    r[10] < 20   // STOCH RSI D
            );

            const bullishPct = Math.round(
                (bullish.length / rows.length) * 100
            );

            setCards([
                {
                    title: "Bullish Stocks",
                    value: bullishPct + "%",
                    count: bullish.length,
                    icon: TrendingUp,
                    color: "text-emerald-400"
                },

                {
                    title: "Breakouts",
                    value: breakouts.length,
                    icon: Activity,
                    color: "text-cyan-400"
                },

                {
                    title: "Oversold",
                    value: oversold.length,
                    icon: RotateCcw,
                    color: "text-amber-400"
                },

                {
                    title: "Weak Stocks",
                    value: weak.length,
                    icon: AlertTriangle,
                    color: "text-red-400"
                }
            ]);

        });

    }, []);

    return (

        <div
            className="
                grid
                grid-cols-1
                md:grid-cols-2
                xl:grid-cols-4
                gap-6
                mb-10
            "
        >

            {cards.map((card, idx) => {

                const Icon = card.icon;

                return (

                    <div
                        key={idx}
                        className="
                            bg-slate-900
                            border
                            border-zinc-800
                            rounded-2xl
                            p-6
                            shadow-sm
                            hover:shadow-md
                            transition-all
                        "
                    >

                        <div
                            className="
                                flex
                                justify-between
                                items-center
                                mb-4
                            "
                        >

                            <Icon
                                size={22}
                                className={card.color}
                            />

                            <span
                                className="
                                    text-xs
                                    text-slate-200
                                "
                            >
                                LIVE
                            </span>

                        </div>

                        <div
                            className="
                                text-3xl
                                font-bold
                                text-slate-100
                            "
                        >
                            {card.value}
                        </div>

                        <div
                            className="
                                text-slate-200
                                mt-2
                            "
                        >
                            {card.title}
                        </div>

                        {card.count !== undefined && (
                            <div
                                className="
                                    text-xs
                                    text-slate-300
                                    mt-1
                                "
                            >
                                {card.count} stocks
                            </div>
                        )}

                    </div>

                );
            })}
        </div>
    );
}